module.exports = __webpack_public_path__ + "img/mm_b2_pic1.f3ccc46e.png";